"use strict";

exports.__esModule = true;
exports.autocompleteRenderer = exports.RENDERER_TYPE = void 0;
var _autocompleteRenderer = require("./autocompleteRenderer");
exports.RENDERER_TYPE = _autocompleteRenderer.RENDERER_TYPE;
exports.autocompleteRenderer = _autocompleteRenderer.autocompleteRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/autocompleteRenderer/index.js
// module id = 233
// module chunks = 0